import React, { useEffect, useState } from 'react';
import { Spin, Alert, Card, Button } from 'antd';
import Layout from '../../components/Layout';
import AntTable from '../../components/CustomTable/AntTable';
import { customBaseUrl, httpPost } from '../../store/http';
import { NotificationManager } from 'react-notifications';

const AllReferrals = () => {
    const [referrals, setReferrals] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });

    const fetchAllReferrals = async (page = 1, pageSize = 10) => {
        setLoading(true);
        try {
            const payload = {
                pageNo: page - 1,
                pageSize: pageSize,
            };
            const res = await httpPost(`${customBaseUrl.referralUrl}/api/v1/admin/fetchAllReferrals`, payload);
            if (res.data && res.data.content) {
                setReferrals(res.data.content);
                setPagination({
                    current: res.data.pageNo + 1,
                    pageSize: res.data.pageSize,
                    total: res.data.totalElements,
                });
            } else {
                setError(res?.message || 'Failed to fetch referrals.');
            }
        } catch (err) {
            setError('An error occurred while fetching referrals.');
            console.error(err);
            NotificationManager.error('An error occurred while fetching referrals.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAllReferrals(pagination.current, pagination.pageSize);
    }, []);

    const handleTableChange = (pagination) => {
        fetchAllReferrals(pagination.current, pagination.pageSize);
    };

    const columns = [
        { title: 'ID', dataIndex: 'id', key: 'id' },
        { title: 'Email', dataIndex: 'email', key: 'email' },
        { title: 'Phone Number', dataIndex: 'phoneNumber', key: 'phoneNumber' },
        { title: 'Referral Code', dataIndex: 'referralCode', key: 'referralCode' },
        { title: 'Reference Code', dataIndex: 'referenceCode', key: 'referenceCode' },
        { title: 'Organization Name', dataIndex: 'organizationName', key: 'organizationName' },
        { title: 'Corporate', dataIndex: 'corporate', key: 'corporate', render: (text) => (text ? 'Yes' : 'No') },
        { title: 'Created At', dataIndex: 'createdAt', key: 'createdAt' },
    ];

    return (
        <>
            <Card title="All Referrals">
                {loading ? (
                    <Spin tip="Loading referrals..." />
                ) : error ? (
                    <Alert message="Error" description={error} type="error" showIcon />
                ) : (
                    <AntTable
                        pagination={pagination}
                        users={referrals}
                        loading={loading}
                        handleGetNext={handleTableChange}
                        columns={columns}
                    />
                )}
            </Card>
        </>
    );
};

export default AllReferrals;
